import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService, CreNgConfig } from 'cre-ng';
import { take } from 'rxjs/operators';

import { AppDataService } from '@app/core/app-data.service';
import { TokenResponse } from './shared/shared.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  confirmReturnDialogVisible: boolean;
  dataReady = false;
  redirectButtonText: string;
  redirecting: boolean;
  showLogoutButton = true;
  year = new Date().getFullYear().toString();
  isTokenExpired = false;
  isValidToken = true;
  private readonly callbackUrl = 'callbackUrl';
  private readonly stateCode = 'state';
  private readonly taskId = 'taskId';
  private readonly ticket = 'ticket';
  private readonly tokenKey = 'redirectTo';
  private readonly username = 'username';

  constructor(
    private appDataService: AppDataService,
    private authService: AuthService,
    private config: CreNgConfig,
    private route: ActivatedRoute,
    private httpClient: HttpClient
  ) {}

  getSecurityEndPoint(): string {
    return '/security/api/v1/jwt/validate?jwt=';
  }

  hideConfirmReturnDialog() {
    this.confirmReturnDialogVisible = true;
    this.redirectToPortalFrom();
  }

  ngOnInit(): void {
    this.redirectButtonText = 'Logout';
    this.processLogin();

    this.appDataService.setRedirectToPortal(false);
    if (window.__env.ngSettings.mock) {
      setTimeout(() => {
        // this.processLogin();
        this.dataReady = true;
      }, 500);
    } else {
      this.authService.login$.pipe(take(1)).subscribe((_) => {
        // this.processLogin();
        this.dataReady = true;
        this.confirmReturnDialogVisible = false;
      });
    }
  }

  processLogin() {
    const httpParams = new HttpParams({ fromString: document.URL.split('?')[1] });
    this.appDataService.ticket = httpParams.get(this.ticket);
    this.redirectButtonText = 'Return to Portal';
    this.appDataService.setRedirectToPortal(true);
    this.appDataService.setOriginId(httpParams.get(this.tokenKey));
    this.appDataService.setSelectedState(httpParams.get(this.stateCode));
    this.appDataService.setTaskId(httpParams.get(this.taskId));
    this.appDataService.setCallbackUrl(httpParams.get(this.callbackUrl));
    this.appDataService.setUsername(httpParams.get(this.username));

    if (this.appDataService.getOriginId() === 'career') {
      this.showLogoutButton = false;
    }
  }

  redirect() {
    if (this.appDataService.getOriginId()) {
      if (this.appDataService.getCallbackUrl()) {
        window.location.href =
          this.appDataService.getCallbackUrl() +
          '?username=' +
          this.appDataService.getUsername() +
          '&taskId=' +
          this.appDataService.getTaskId();
      } else {
        window.location.href =
          window.__env.ngSettings.serviceApiDomain + '/' + this.appDataService.getOriginId();
      }
      localStorage.clear();
    } else {
      this.redirecting = false;
    }
  }

  reloadPage() {
    window.location.reload();
  }

  validateToken(): Promise<TokenResponse> {
    const url =
      window.__env.ngSettings.serviceApiDomain +
      this.getSecurityEndPoint() +
      this.appDataService.getUserToken();
    const httpHeaders = this.getHttpHeaders();
    const requestOptions = { headers: httpHeaders };
    return this.httpClient.get<TokenResponse>(url, requestOptions).toPromise();
  }

  isTokenValid(): void {
    this.validateToken()
      .then((data) => {
        if (data.valid === false) {
          this.isValidToken = false;
        }
      })
      .catch((ex) => {
        console.log(ex);
      });
  }

  getHttpHeaders(): HttpHeaders {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${this.appDataService.getUserToken()}`,
    });

    return headers;
  }

  private redirectToPortalFrom() {
    this.confirmReturnDialogVisible = false;
    this.redirecting = true;
    this.appDataService.setRedirectToPortal(true);
    this.redirect();
  }
}
